<template>
    <b-row no-gutters>
        <b-col class="px-4 py-3">
            <h4 class="pb-2">
                Simple Product
            </h4>
            <section>
                <div class="border-bottom px-3">
                    <b-row no-gutters>
                        <b-col>
                            <div class="d-inline-block px-3" style="width: 140px;">
                                <switches 
                                    v-model="values.visibility"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    label="Visibility"
                                    id="visibility_switch">
                                </switches>
                            </div>
                            <div class="d-inline-block px-3" style="width: 165px;">
                                <switches 
                                    v-model="values.on_sale"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    label="Item on Sale"
                                    id="sale_switch">
                                </switches>
                            </div>
                            <div class="d-inline-block px-3" style="width: 150px;">
                                <switches 
                                    v-model="values.is_stocks"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    label="Stock Quantity"
                                    id="visibility_switch">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="px-3 py-3">
                    <b-row>
                        <b-col cols="3">
                            <div id="regular-price-container">
                                <b-form-group
                                    id="currencyGroup"
                                    label="Regular Price"
                                    label-for="currency"
                                    class="secondary-label"
                                    :invalid-feedback="errorMessage('price')"
                                    :state="isValid('price')">
                                    <b-input-group>
                                        <b-form-select
                                            slot="prepend"
                                            :options="values.options.currency"
                                            v-model="values.currency">
                                        </b-form-select>
                                        <b-form-input 
                                            id="regularPrice"
                                            v-model="values.price"
                                            required
                                            type="number"
                                            min="1"
                                            max="10000000000"
                                            oninput="this.value = Math.abs(this.value)" />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                                id="skuGroup"
                                label="SKU"
                                label-for="sku"
                                class="secondary-label mb-2"
                                :invalid-feedback="errorMessage('sku')"
                                :state="isValid('sku')">
                                <b-form-input
                                    id="sku"
                                    type="text"
                                    v-model="values.sku"
                                    :disabled="editingFromLocationsPage"
                                    required
                                    :formatter="skuFormatter"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2">
                            <b-form-group
                                id="stockGroup"
                                label="Stock"
                                label-for="stock"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('stock')"
                                :state="isValid('stock')">
                                <b-form-input
                                    id="duration"
                                    type="number"
                                    :disabled="!values.is_stocks"
                                    v-model="values.stocks"
                                    required min="0"
                                    oninput="this.value = Math.abs(this.value)">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row v-if="values.on_sale">
                        <b-col cols="3">
                            <div id="discount-price-container">
                                <b-form-group
                                    id="discountGroup"
                                    label="Discount"
                                    label-for="discount"
                                    class="secondary-label"
                                    :invalid-feedback="errorMessage('sale_value')"
                                    :state="isValid('sale_value')">
                                    <b-input-group>
                                        <b-form-select 
                                            slot="prepend"
                                            :options="values.options.discount"
                                            v-model="values.sale_type">
                                        </b-form-select>
                                        <b-form-input 
                                            id="regularPrice"
                                            v-model="values.sale_value"
                                            required
                                            type="number"
                                            :min="payment == 'CC' ? '1' : '0'"
                                            :max="values.sale_type == '%' ? 99 : null"
                                            :formatter="discountFormatter" />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <b-form-group
                                id="scheduleGroup"
                                label="Schedule"
                                label-for="schedule"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('sale_from')"
                                :state="isValid('sale_to')">
                                <div id="schedule-container">
                                    <b-input-group>
                                        <b-input-group slot="append">
                                            <i class="icon-calendar"></i>
                                        </b-input-group>
                                        <datepicker
                                            v-model="values.date_range"
                                            :config="dateRangeConfig">
                                        </datepicker>
                                    </b-input-group>
                                </div>
                            </b-form-group>                                                              
                        </b-col>
                    </b-row>
                </div>
            </section>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";

export default {
    name: "SimpleProduct",
    props: ["values", "origin", "payment"],
    components: {
        Switches,
        Datepicker
    },
    computed: {
        ...mapState("dstoreInventories", ["errors"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // minDate: "today",
                    defaultDate: ["today", "today"]
                };
            }
        }
    },
    methods: {
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },

        discountFormatter: function(value, event) {
            if (event === null) {
                return value;
            }

            if (this.values.sale_type === "%") {
                if (value > 99) {
                    return 99;
                }
            } else {
                if (
                    Number(value) > this.values.price ||
                    Number(value) == this.values.price
                ) {
                    return this.values.price - 1 < 0
                        ? 0
                        : this.values.price - 1;
                }
            }
            return value;
        },

        skuFormatter(value, event) {
            return event === null ? value : value.replace(/[^\w-]/gi, "");
        }
    }
};
</script>
